import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BannerContent = ({
  onClose,
  children
}) => /*#__PURE__*/_jsxs(TFlex, {
  align: "center",
  justify: "between",
  position: "relative",
  marginBlock: "-200",
  marginInline: "100",
  children: [/*#__PURE__*/_jsx(View, {
    children: children
  }), /*#__PURE__*/_jsx(CloseButton, {
    color: "icon-core-subtle",
    insetBlockStart: "0",
    insetInlineEnd: "0",
    onClick: onClose,
    position: "relative"
  })]
});
BannerContent.displayName = 'BannerContent';
export default BannerContent;